'use strict';

angular.module('app.constants', [])
  .constant('DATE_FORMAT', {
    moment: {
      date: 'M/DD/YY',
      time: 'h:mm a'
    },
    angular: {
      date: 'M/dd/yy',
      time: 'h:mm a'
    }
  })
  .constant('DEFAULT_PROFILE_IMAGE', 'assets/images/user_profile_placeholder.jpg')
  .constant('RECURLY_API_KEY', 'ewr1-65dt862ZxyPyho5vYGG35D')
  .constant('GOOGLE_CLIENT_ID', '76399356767.apps.googleusercontent.com')
  .constant('JW_PLAYER_KEY', "NkPuGDODe1q+hm5P59a4amDej8jVjRnaaUYNE7Cs489xR7Ch")
  .constant('PLAYER_POSTERS', {
    'notStarted': "assets/images/player/ahltv/ahltv_stream_has_not_started.png",
    'startingSoon': "assets/images/player/ahltv/ahltv_stream_starting_soon.png"
  })
  .constant('FIREBASE_CREDS', {
    'live-scoring': {
      connection: {
        apiKey: "AIzaSyAjLkdlvcEPyyGeaBUrDn-zknTPehGfnF4",
        authDomain: "htv-staging-realtimeclock2.firebaseapp.com",
        databaseURL: "https://htv-staging-realtimeclock2-default-rtdb.firebaseio.com",
        projectId: "htv-staging-realtimeclock2",
        storageBucket: "htv-staging-realtimeclock2.appspot.com",
        messagingSenderId: "196292062868"
      }
    },
    'chat': {
      connection: {
        apiKey: "AIzaSyBANT1vNIqoKw9saOz3WnIoN4pIqYTljPk",
        authDomain: "htv-dev-2.firebaseapp.com",
        databaseURL: "https://htv-dev-2.firebaseio.com",
        projectId: "htv-dev-2",
        storageBucket: "htv-dev-2.appspot.com",
        messagingSenderId: "194373651147"
      }
    },
    'leaguestat': {
      firebaseUrl: 'leaguestat-staging.firebaseio.com',
      firebaseApiKey: 'AIzaSyDiVf2xYgmTlohuJMGJVHLnyNek-oEpBK4',
      firebaseToken: 'DIN13azYJqHGpWrohj04Jz37kn5GLNIGoWec5Ql2'
    },
    'singular': {
      firebaseUrl: 'htv-staging-realtimeclock2-default-rtdb.firebaseio.com',
      firebaseApiKey: 'AIzaSyAjLkdlvcEPyyGeaBUrDn-zknTPehGfnF4',
      firebaseToken: 'Gc3VR5H6Fi3PJKKiP4npPnJu5UQitq4rNIPGceL9'
    }
  })
  .constant('CURRENT_SEASON', 35)
  .constant('SYNDICATION_URL', "https://syndicate.hockeytv.com/login/ahl.php")
  .constant('LEAGUESTAT_API', {
    'clusterUrl': "https://lscluster.hockeytech.com",
    'clusterKey': "f048f7ce7c422906"
  })
  .constant('PRODUCT', {
    'Id': 2,
    'Code': "ahl",
    'Name': "AHLTV",
    'StorageBucket': "https://s3.amazonaws.com/assets.ahltv.com"
  })
  .constant('ADMIN_API_URL', "https://admin.htvstaging.com/api")
  .constant('ENVIRONMENT', {
    production: false
  });



// WEBPACK FOOTER //
// ./app.v2/components/fhApp/constants/ahl-constants-staging.js